import { Link } from "react-router-dom";
import styled from "styled-components";

// Fixed quick-nav for phones only. Sits above content (sticky layer), below
// the mobile menu / modals so those still cover it when open.
export const Bar = styled.nav`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    align-items: stretch;
    gap: 4px;

    /* Floating pill — inset from the edges, not edge-to-edge. */
    position: fixed;
    left: 12px;
    right: 12px;
    bottom: calc(10px + env(safe-area-inset-bottom, 0px));
    z-index: ${({ theme }) => theme.zIndex.sticky};

    padding: 5px;
    border-radius: 16px;

    background: rgba(26, 35, 50, 0.72);
    backdrop-filter: blur(18px) saturate(140%);
    -webkit-backdrop-filter: blur(18px) saturate(140%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow:
      0 4px 16px rgba(8, 14, 26, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.04);
  }
`;

const itemBase = `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-height: 44px;
  border-radius: 11px;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  transition: all 300ms ease;
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;

// Ghost item — fleet browsing.
export const BarLink = styled(Link)`
  ${itemBase}
  background: ${({ $active }) =>
    $active ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.04)"};
  border: 1px solid
    ${({ $active }) =>
      $active ? "rgba(163, 185, 205, 0.5)" : "rgba(255, 255, 255, 0.12)"};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primaryLight : "rgba(255, 255, 255, 0.9)"};

  &:active {
    transform: scale(0.97);
  }
`;

// Filled accent item — primary conversion (Request a Quote).
export const BarCta = styled(Link)`
  ${itemBase}
  background: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 8px rgba(112, 141, 171, 0.22);

  &:active {
    transform: scale(0.97);
  }
`;
